import React from 'react';
import "../global/components/scroll-bar.css";
import { API_URL } from '../global/components/Constants';
import { continueBtn } from './controlUtils';
import { hexToRgba } from './colorUtils';
import { ef } from './effectUtils';
import { displayTitleUtil } from './topicComponent/titleUtils';
import { displayInputUtil } from './topicComponent/inputUtils';
import { displayGraphUtil } from './topicComponent/graphUtils';
import { displayCardUtil } from './topicComponent/cardUtils';
import { displaySectionUtil } from './topicComponent/sectionUtils';
import { displayTableUtil } from './topicComponent/tableUtils';
import { displayArrowUtil } from './topicComponent/arrowUtils';
import { displayRuleUtil } from './topicComponent/ruleUtils';
import { displayShapeUtil } from './topicComponent/shapeUtils';
import { displayListUtil } from './topicComponent/listUtils';
import { displayPhotoUtil } from './topicComponent/photoUtils';
import EditorTitle from '../topic/components/EditorTitle';
import EditorInput from '../topic/components/EditorInput';
import EditorList from '../topic/components/EditorList';
import EditorPhoto from '../topic/components/EditorPhoto';
import EditorGraph from '../topic/components/EditorGraph';
import EditorTable from '../topic/components/EditorTable';
import EditorCard from '../topic/components/EditorCard';
import EditorSection from '../topic/components/EditorSection';
import EditorArrow from '../topic/components/EditorArrow';
import EditorRule from '../topic/components/EditorRule';
import EditorShape from '../topic/components/EditorShape';
import EditorContainer from '../topic/components/EditorContainer';

export function displayEditorUtil(params){
    let editor = <></>;
    if(params.editor == "Title"){
        editor = <EditorTitle params = {params} />;
    }else if(params.editor == "Input"){
        editor = <EditorInput params = {params} />;
    }else if(params.editor == "Photo"){
        editor = <EditorPhoto params = {params} />;
    }else if(params.editor == "List"){
        editor = <EditorList params = {params} />;
    }else if(params.editor == "Graph"){
        editor = <EditorGraph params = {params} />;
    }else if(params.editor == "Table"){
        editor = <EditorTable params = {params} />;
    }else if(params.editor == "Card"){
        editor = <EditorCard params = {params} />;
    }else if(params.editor == "Section"){
        editor = <EditorSection params = {params} />;
    }else if(params.editor == "Arrow"){
        editor = <EditorArrow params = {params} />;
    }else if(params.editor == "Rule"){
        editor = <EditorRule params = {params} />;
    }else if(params.editor == "Shape"){
        editor = <EditorShape params = {params} />;
    }else if(params.editor == "Container"){
        editor = <EditorContainer params = {params} />;
    }
    return editor;
} 

export function displayTopicCompUtil(obj, entryPoint){
    switch(obj.ComponentType){
        case 'title':
            return displayTitleUtil(obj, entryPoint);
            break;
        case 'text':
            return displayInputUtil(obj, entryPoint);
            break;
        case 'html':
            return displayInputUtil(obj, entryPoint);
            break;
        case 'code':
            return displayInputUtil(obj, entryPoint);
            break;
        case 'list':
            return displayListUtil(obj, entryPoint);
            break;
        case 'table':
            return displayTableUtil(obj, entryPoint);
            break;
        case 'note':
            return displayInputUtil(obj, entryPoint);
            break;
        case 'photo':
            return displayPhotoUtil(obj, entryPoint);
            break;
        case 'video':
            return displayInputUtil(obj, entryPoint);
            break;
        case 'graph':
            return displayGraphUtil(obj, entryPoint);
            break;
        case 'card':
            return displayCardUtil(obj, entryPoint);
            break;
        case 'section':
            return displaySectionUtil(obj, entryPoint);
            break;
        case 'arrow':
            return displayArrowUtil(obj, entryPoint);
            break;
        case 'rule':
            return displayRuleUtil(obj, entryPoint);
            break;
        case 'shape':
            return displayShapeUtil(obj, entryPoint);
            break;
    }
}

export function displayTopicUtil(obj, action){
    
    const src = `${API_URL}/uploads/topic/${obj.Photo}`;
    
    const colors = obj.Theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];
    
    const styles = {
        section: {
            background: bgColor,
            display:'flex',
            overflow: 'hidden',
            borderRadius: 5
        },
        contentWrap:{
            flex: 1,
            padding: '40px 30px',
        },
        title:{
            color: txtColor,
            fontSize: 38
        },
        desc:{
            color: txtColor,
            marginBottom: 20,
            fontSize: 24
        },
        photoWrap:{
            flex: 1,
            backgroundImage: `url(${src})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
        },
        photo:{
            width: '100%',
            marginBottom:0
        },
    }
    
    return (
        <div style={styles.section}>
            <div style={styles.contentWrap}>
                <h4 style={styles.title}>
                    {ef(obj.Title, 'zoom', 0.8 )}
                </h4>
                <div style={styles.desc}>
                    {ef(obj.Description, 'zoom', 1.1 )}
                </div>
                {ef(continueBtn(action, "lg"), 'zoom', 1.2 )}
            </div>
            {(obj.Photo != "") &&
                <div style={styles.photoWrap}></div>
            }
        </div>
    )
}

export function blind(obj){
    const content = JSON.parse(obj.Content);
    const theme = content.Theme;
    
    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    const styles = {
        blind:{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: hexToRgba(bgColor, 0.8),
            zIndex: 99,
        },
    }

    return (
        <div style={styles.blind}></div>
    )
}

export const topicThemes = [
    {Id: 1, Name: "Default", Value: "#fff-#212529-#c1c1c1-#666-#ddd"},
    {Id: 2, Name: "Pale", Value: "#edf4f3-#212529-#c1c1c1-#999-#ccc"},
    {Id: 3, Name: "Bluish", Value: "#cff0f9-#212529-#c1c1c1-#666-#ccc"},
    {Id: 4, Name: "Blue", Value: "#337ab7-#fff-#2e6da4-#e2ebfe-#74a6c6"},
    {Id: 5, Name: "Yellowish", Value: "#fdfdca-#212529-#c1c1c1-#666-#e8dab9"},
    {Id: 6, Name: "Yellow", Value: "#f0ad4e-#fff-#eea236-#f7f6f2-#ddca9b"},
    {Id: 7, Name: "Greenish", Value: "#d8f4e6-#212529-#c1c1c1-#666-#ccc"},
    {Id: 8, Name: "Green", Value: "#5cb85c-#fff-#4cae4c-#dffbda-#83d27c"},
    {Id: 9, Name: "Dark",  Value: "#2c2b30-#eee-#c1c1c1-#e1e1e1-#7b7b7b"},
];

export const mPInit = {
    Margin: {
        Top: 0,
        Right: 0,
        Bottom: 0,
        Left: 0
    },
    Padding: {
        Top: 0,
        Right: 0,
        Bottom: 0,
        Left: 0
    }
}

export const previewInit = (
    <div style={{textAlign: 'center'}}>
        <img src='../../images/topic-preview.png' style={{width:60, marginBottom:20}} />
        <h4 style={{color:'#666',fontSize:14,fontWeight:600}}>
            ENTRY PREVIEW
        </h4>
        <div style={{color:'#666',fontSize:13}}>
            Enter values to see preview
        </div>
    </div>
)

export const entryPoint = {
    display: 'display',
    editor: 'edit',
    editor: 'editor',
    presentation: 'presentation'
}






